export default () => {
  const bookmarkRecommendModal = $('#bookmark-recommend-modal');

  if (bookmarkRecommendModal) {
    const disableBookmarkRecommend = () => {
      // MEMO: エラー通知が多いためCSRFトークンを無効にする
      const xmlHR = new XMLHttpRequest();
      const regexp = new RegExp('/([^/]*)/*');
      const schoolName = regexp.exec(location.pathname)[1];
      const url = `${location.protocol}//${window.location.host}/api/v1/student/schools/${schoolName}/disable_bookmark_recommend`;

      xmlHR.open('PATCH', url, false);
      xmlHR.send({});
    };

    bookmarkRecommendModal.modal('show');
    bookmarkRecommendModal.on('hidden.bs.modal', function () {
      if ($('#bookmark-recommend').is(':checked')) {
        disableBookmarkRecommend();
      }
    });
  }
};
